<template>
    <div>
        <md-menu v-for="(chip, index) in chips" :key="index">
            <md-chip class="" md-clickable md-menu-trigger @click="onChipClick(chip)">{{ $t(`chips.${chip.name}.label`) }}</md-chip>
            <md-menu-content v-if="!chip.code">
                <md-menu-item v-for="(field, childIndex) in chip.fields" :key="childIndex" @click="onChipClick(field)">{{ $t(`chips.${chip.name}.${field.name}`) }}</md-menu-item>
            </md-menu-content>
        </md-menu>
    </div>
</template>
<script>
    export default {
        name: 'AdsignChips',
        props: {
            //expected model
            // Combine element, with menu representation
            //{
            //     name: "order",
            //     fields: [
            //         {
            //             name: "title",
            //             code: "${order.title}"
            //         },
            //         {
            //             name: "value",
            //             code: "${order.value}"
            //         }
            //     ]
            // },
            // Simple model
            // {
            //     name: "activationLink",
            //     code: '${activationLink}'
            // }
            chips: {
                type: Array,
                required: true
            }
        },
        methods: {
            onChipClick(event) {
                if (event.code) {
                    this.$emit('chipEntered', event);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep {
        .md-menu .md-chip {
            margin-right: 5px;
        }
    }
</style>
